import SkipNextIcon from '@mui/icons-material/SkipNext';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import EjectIcon from '@mui/icons-material/Eject';
import ReplyIcon from '@mui/icons-material/Reply';
import type { SvgIconComponent } from '@mui/icons-material';
import type { TranslationKey } from '@/i18n/translation-key';
import {
  DEFAULT_MEDIA_PLAYLIST_ADVANCE_MODE,
  MEDIA_PLAYLIST_ADVANCE_MODES,
  type MediaPlaylistAdvanceMode,
  type StoredMediaPlaylistAdvanceMode,
} from '@/types/dtos/media/media-playlist-advance-mode.enum';

const CYCLABLE_ADVANCE_MODES: MediaPlaylistAdvanceMode[] = [...MEDIA_PLAYLIST_ADVANCE_MODES];

export function resolveMediaPlaylistAdvanceMode(
  advanceMode?: StoredMediaPlaylistAdvanceMode | string,
  fileType?: string,
): MediaPlaylistAdvanceMode {
  void fileType;
  if (advanceMode === 'skip') {
    return 'skip';
  }
  if (advanceMode === 'show_info') {
    return 'show_info';
  }
  if (advanceMode === 'return_previous') {
    return 'return_previous';
  }
  return DEFAULT_MEDIA_PLAYLIST_ADVANCE_MODE;
}

export function cycleMediaPlaylistAdvanceMode(
  current?: StoredMediaPlaylistAdvanceMode | string,
  fileType?: string,
): MediaPlaylistAdvanceMode {
  const resolved = resolveMediaPlaylistAdvanceMode(current, fileType);
  const index = CYCLABLE_ADVANCE_MODES.indexOf(resolved);
  const nextIndex = index < 0 ? 0 : (index + 1) % CYCLABLE_ADVANCE_MODES.length;
  return CYCLABLE_ADVANCE_MODES[nextIndex]!;
}

type AdvanceModeDisplay = {
  Icon: SvgIconComponent;
  tooltipKey: TranslationKey;
};

export const MEDIA_PLAYLIST_ADVANCE_MODE_DISPLAY: Record<MediaPlaylistAdvanceMode, AdvanceModeDisplay> = {
  advance: { Icon: SkipNextIcon, tooltipKey: 'media.playlistAdvanceMode.advance' },
  show_info: { Icon: EjectIcon, tooltipKey: 'media.playlistAdvanceMode.showInfo' },
  skip: { Icon: VisibilityOffIcon, tooltipKey: 'media.playlistAdvanceMode.skip' },
  return_previous: { Icon: ReplyIcon, tooltipKey: 'media.playlistAdvanceMode.returnPrevious' },
};

export function getMediaPlaylistAdvanceModeIconColor(mode: MediaPlaylistAdvanceMode): 'action' | 'info' | 'warning' {
  if (mode === 'skip') {
    return 'info';
  }
  if (mode === 'show_info') {
    return 'info';
  }
  if (mode === 'return_previous') {
    return 'info';
  }
  return 'action';
}

export function getMediaPlaylistAdvanceModeDisplay(
  advanceMode?: StoredMediaPlaylistAdvanceMode | string,
  fileType?: string,
): AdvanceModeDisplay {
  return MEDIA_PLAYLIST_ADVANCE_MODE_DISPLAY[resolveMediaPlaylistAdvanceMode(advanceMode, fileType)];
}

/** Repeat remains in stored data for compatibility but is not offered in the UI cycle. */
export function isRepeatAdvanceModeOffered(fileType?: string): boolean {
  void fileType;
  return false;
}

export { MEDIA_PLAYLIST_ADVANCE_MODES };
